import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appScrollIntoView]',
    standalone: false
})
export class ScrollIntoViewDirective implements AfterViewInit {
  @Input() appScrollIntoView = false;
  
  constructor(private el: ElementRef) {}
  
  ngAfterViewInit() {
    if (this.appScrollIntoView) {
      setTimeout(() => {
        this.el.nativeElement.scrollIntoView({ 
          behavior: 'auto', 
          block: 'start' 
        });
      }, 0);
    }
  }

}